import { useState } from "react";
import { ReactComponent as ChargingStationIcon } from "../../Assets/Icons/ChargerIcon.svg";

import { Typography } from "@mui/material";
import { isMobile } from "react-device-detect";
import LandingAnimation from "../../Helpers/LandingAnimation";
import { ColorScheme } from "../../Themes/ColorScheme";
import { MuiDrawer } from "../Common/MuiDrawer";
import { ChargerForm } from "./ChargerForm";
import { ChargerIcon } from "./Components/ChargerIcon";
import { ChargerLogs } from "./Components/ChargerLogs";
import { PowerOutput } from "./Components/PowerOutput";
import { WalletIcon } from "./Components/WalletIcon";

import { useTranslation } from "react-i18next";
import { ChargingTransactions } from "./ChargingTransactions";

export const ChargerCard = ({ data, fetchChargers }) => {

	const { t } = useTranslation();
	
	const [drawerContent, setDrawerContent] = useState(null);

	const [hover, setHover] = useState(false);

	const cardStyle = {
		minWidth: isMobile ? undefined : "300px",
		width: isMobile ? undefined : "200px",
		display: "flex",
		flexDirection: "column",
		backgroundColor: ColorScheme.secondary,
		borderRadius: "4px",
		alignItems: "center",
		justifyContent: "space-between",
		cursor: "pointer",
		padding: "20px",
		color: ColorScheme.black,
		overflow: "hidden",
		transition: "color 0.3s ease, transform 0.3s ease"
	};

	if (hover) cardStyle.transform = "scale(1.01)";

	const chargerName = String(data.id).padStart(4, "0");
	const maxPower = data?.max_power ?? "--";
	const basePrice = data?.base_vat_price ?? "--";

	const svgIcon = data?.type.icon;

	const strokeWidthStation = 2;
	const heightStation = 26;
	const widthStation = 26;

	const strokeColor = ColorScheme.black;
	// const fillColor = ColorScheme.black;
	const strokeWidth = 3;
	// const chargerIconMultiplier = 3.5;
	const height = 30;
	const width = 30;

	const getStatusColor = (status) => {
		switch (status) {
			case "Available":
				return ColorScheme.successPrimary;

			case "Preparing":
				return ColorScheme.warningPrimary;

			default:
				return ColorScheme.dangerPrimary;
		}
	};

	const getIconColor = (status) => {
		switch (status) {
			case "Available":
				return ColorScheme.successSecondary;
			case "Preparing":
				return ColorScheme.warningSecondary;
			default:
				return ColorScheme.dangerSecondary;
		}
	};

	const handleClose = () => {
		setDrawerContent(null);
		fetchChargers();
	};

	return (
		<LandingAnimation>
			<div>
				<MuiDrawer
					title={drawerContent?.title}
					subtitle={chargerName}
					open={drawerContent !== null}
					subview={drawerContent?.content}
					handleDrawerClose={() => handleClose()}
				/>
				<div
					onClick={(event) => {
						event.stopPropagation();
						setDrawerContent({
							content: <ChargerForm data={data}  handleDrawerClose={handleClose} />,
							title: t("charging.charger")
					});
					}}
					onMouseEnter={() => setHover(true)}
					onMouseLeave={() => setHover(false)}
					direction="row"
					style={cardStyle}
				>
					<div
						style={{
							flexDirection: "row",
							display: "flex",
							justifyContent: "space-between",
							width: isMobile ? "80dvw" : "100%"
						}}
					>
						<div
							style={{
								width: "100%",
								height: "100%",
								flexDirection: "row",
								display: "flex",
								alignItems: "center"
							}}
						>
							<div
								style={{
									display: "flex",
									flexDirection: "row",
									width: "100%",
									alignItems: "center",
									justifyContent: "space-between"
								}}
							>
								<div
									style={{
										display: "flex",
										flexDirection: "row",
										alignItems: "center"
									}}
								>
									<div
										style={{
											width: "40px",
											height: "40px",
											borderRadius: "4px",
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
											backgroundColor: getStatusColor(
												data.connector_status
											),
											border:
												"4px solid" +
												getStatusColor(
													data.connector_status
												)
										}}
									>
										<ChargingStationIcon
											stroke={getIconColor(data.connector_status)} // change by status
											width={widthStation}
											heigth={heightStation}
											strokeWidth={strokeWidthStation}
										/>
									</div>
									<div
										style={{
											flexDirection: "column",
											display: "flex",
											marginLeft: "15px",
											flex: 1
										}}
									>
										<Typography
											style={{
												fontSize: "24px",
												fontWeight: "700"
											}}
										>
											{chargerName}
										</Typography>
										<Typography
											style={{
												fontSize: "16px",
												fontWeight: "700",
												color: ColorScheme.textSecondary,
												marginTop: "-10px",
												whiteSpace: "nowrap",
												textOverflow: "ellipsis",
												overflow: "hidden",
												flex: 1
											}}
										>
											{
												data?.charge_point
													?.charge_point_name
											}
										</Typography>
									</div>
								</div>
								<div>
									<Typography fontSize="14px" color={ColorScheme.darkGrey}>
										{data.connector_status}
									</Typography>
								</div>
							</div>
						</div>
					</div>

					<div
						style={{
							height: "20px"
						}}
					/>

					<div
						style={{
							backgroundColor: ColorScheme.lightGrey,
							borderRadius: "4px",
							padding: "20px",
							alignItems: "baseline",
							width: isMobile ? "70dvw" : "85%",
							display: "flex",
							flexDirection: "row",
							justifyContent: "space-between"
						}}
					>
						<ChargerIcon
							data={data}
							svgIcon={svgIcon}
							strokeColor={strokeColor}
							strokeWidth={strokeWidth}
							iconWidth={width}
							iconHeight={height}
						/>

						<WalletIcon
							basePrice={basePrice}
							iconWidth={width}
							iconHeigth={height}
							strokeColor={strokeColor}
							strokeWidth={strokeWidth}
						/>

						<PowerOutput
							maxPower={maxPower}
							width={width}
							heigth={height}
							strokeColor={strokeColor}
							strokeWidth={strokeWidth}
						/>
						
						<ChargerLogs
							handleClick={() => {
								setDrawerContent(
									{content:
										<ChargingTransactions
											data={data}
											handleDrawerClose={handleClose}
										/>,
										title: t("charging.transactions")
									}
								);
							}}
							strokeColor={strokeColor}
							strokeWidth={strokeWidth}
							width={width}
							height={height}
						/>
					</div>
				</div>
			</div>
		</LandingAnimation>
	);
};
